var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#16_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.084 8.584a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V11.3l-1.482 1.471a6.75 6.75 0 0 1-9.256.272 6.75 6.75 0 0 1-1.724-2.396l-.155-.397-.022-.074a.75.75 0 0 1 1.436-.427 5.253 5.253 0 0 0 6.408 3.292 5.25 5.25 0 0 0 2.255-1.332l.002-.002 1.636-1.624h-2.348a.75.75 0 0 1 0-1.5zM6.212 1.517a6.753 6.753 0 0 1 8.24 4.233.75.75 0 0 1-1.415.5 5.252 5.252 0 0 0-8.663-1.96l-.002.003-1.636 1.624h2.348a.75.75 0 1 1 0 1.5h-4a.75.75 0 0 1-.75-.75v-4a.75.75 0 0 1 1.5 0v2.031l1.481-1.47a6.75 6.75 0 0 1 2.897-1.71"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "16_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.084 0h16v16h-16z"
  })))));
};
export default Svg16;